module.exports = __webpack_public_path__ + "static/img/Justice.648b67f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Justice.jpg
// module id = 1274
// module chunks = 0